import React from 'react';
import styles from './DualSymbolCardMobile.module.scss';

interface DualSymbolCardMobileProps {
  title1: string;
  detail1: string;
  title2: string;
  detail2: string;
  backgroundColor: string;
  textColor: string;
  detailColor: string;
  symbol: string;
  symbolDetail: string;
  icon: string;
}

const DualSymbolCardMobile: React.FC<DualSymbolCardMobileProps> = ({
  title1,
  detail1,
  title2,
  detail2,
  backgroundColor,
  textColor,
  detailColor,
  symbol,
  symbolDetail,
  icon,
}) => {
  return (
    <div className={styles.card} style={{ backgroundColor }}>
      <div className={styles.iconContainer}>
        <img src={icon} alt="card-icon" />
      </div>
      <div className={styles.content}>
        <div className={styles.symbolContainer}>
          <span className={styles.symbol} style={{ color: textColor }}>
            {symbol}
          </span>
          <span className={styles.symbolDetail} style={{ color: textColor }}>
            {symbolDetail}
          </span>
        </div>
        <div className={styles.textContainer}>
          <div className={styles.titleDetail}>
            <span className={styles.title} style={{ color: textColor }}>
              {title1}
            </span>
            <span className={styles.detail} style={{ color: detailColor }}>
              {detail1}
            </span>
          </div>
          <div className={styles.titleDetail}>
            <span className={styles.title} style={{ color: textColor }}>
              {title2}
            </span>
            <span className={styles.detail} style={{ color: detailColor }}>
              {detail2}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualSymbolCardMobile;
